
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./resources/app/js/main/app.js";
              export default OriginalModule.default;
              export * from "./resources/app/js/main/app.js";